import axios from "axios";
// import io from 'socket.io-client';
 
//*BASE URL LOCAL
 
// frontend
// axios.defaults.baseURL= process.env.REACT_APP_LOCAL_BASE_URL_FRONTEND;
 
 
// 
// test server build ip my laptop
//axios.defaults.baseURL = process.env.REACT_APP_LOCAL_BASE_URL_LOCAL;

 
 
// *BASE URL PRODUCTION RESTAURANT
axios.defaults.baseURL = 'https://apirest.eyeterp.com/';

// *aws api url for production build
//axios.defaults.baseURL = 'https://apirestaw.thalipe.com/';
 
//*HEADERS:
//json Body
export const HEADERS = {
  headers: {
    "Content-Type": "application/json",
  },
};
//Query
export const HEADER_QUERY = {
  "Content-Type": "application/json",
};
//FormData
export const HEADER_FORM_DATA = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};
 
// <-------- web socket connection --------------->
 
// export const socket = io(axios.defaults.baseURL);
 
// <----------------------------------------------->